import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Car,
  ShieldAlert,
  Settings,
  Menu,
  Bell,
  Search,
  User,
  ShieldCheck,
  MonitorSmartphone,
  BarChart3,
} from "lucide-react";

const navItems = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/db" },
  { key: "statistik", label: "Statistik", icon: BarChart3, path: "/db/statistik" },
  { key: "widget", label: "Monitor-Widget", icon: MonitorSmartphone, path: "/widget?ssg=true" },
  { key: "einfahrt", label: "Einfahrterlaubnisse", icon: Car, path: "/einfahrterlaubnisse", badge: "6" },
  { key: "sperren", label: "Terrorsperren", icon: ShieldAlert, path: "/terrorsperren" },
  { key: "einstellungen", label: "Einstellungen", icon: Settings, path: "/einstellungen" },
];

export default function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="al-wrapper">
      {collapsed && window.innerWidth <= 768 && (
        <div className="al-overlay" onClick={() => setCollapsed(false)} data-testid="sidebar-overlay" />
      )}

      <aside className={`al-sidebar ${collapsed ? "collapsed" : ""}`} data-testid="sidebar">
        <div className="al-brand">
          <span className="al-brand-icon">
            <ShieldCheck size={20} />
          </span>
          <span>SecureGate</span>
        </div>

        <div className="al-user">
          <span className="avatar">
            <User size={18} />
          </span>
          <div>
            <div style={{ color: "#fff", fontSize: "0.9rem", fontWeight: 600 }}>Leitstelle</div>
            <div style={{ fontSize: "0.75rem", color: "#8a929a" }}>
              <span style={{ color: "#28a745" }}>●</span> Online
            </div>
          </div>
        </div>

        <ul className="al-nav">
          <li className="al-nav-header">Navigation</li>
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.path;
            return (
              <li key={item.key}>
                <div
                  className={`al-nav-link ${active ? "active" : ""}`}
                  onClick={() => {
                    navigate(item.path);
                    if (window.innerWidth <= 768) setCollapsed(false);
                  }}
                  data-testid={`nav-${item.key}`}
                >
                  <Icon size={18} />
                  <span>{item.label}</span>
                  {item.badge && <span className="badge">{item.badge}</span>}
                </div>
              </li>
            );
          })}
        </ul>
      </aside>

      <div className={`al-main ${collapsed ? "expanded" : ""}`}>
        <nav className="al-navbar">
          <button
            className="nav-btn"
            onClick={() => setCollapsed((c) => !c)}
            data-testid="sidebar-toggle"
            aria-label="Menü umschalten"
          >
            <Menu size={20} />
          </button>
          <span className="spacer" />
          <button className="nav-btn" data-testid="navbar-search" aria-label="Suche">
            <Search size={18} />
          </button>
          <button className="nav-btn" style={{ position: "relative" }} data-testid="navbar-notifications" aria-label="Benachrichtigungen">
            <Bell size={18} />
            <span
              style={{
                position: "absolute",
                top: 4,
                right: 4,
                width: 8,
                height: 8,
                background: "#dc3545",
                borderRadius: "50%",
              }}
            />
          </button>
          <button className="nav-btn" data-testid="navbar-user" aria-label="Benutzer">
            <User size={18} />
          </button>
        </nav>

        {children}

        <footer className="al-footer">
          <div>
            <strong>SecureGate</strong> &copy; 2026 – Sicherheitskontroll-Dashboard
          </div>
          <div>Version 0.1 · AdminLTE v4</div>
        </footer>
      </div>
    </div>
  );
}
